<template>
  <div class="overlay" :class="{ 'is-opened': isOpened }" @click="clickHandler"></div>
</template>

<script>
import { useEventBus } from '@/utils/bus';

export default {
  data() {
    return {
      isOpened: false,
    };
  },

  methods: {
    clickHandler() {
      this.busEmit('overlay-click');
    },
  },

  mounted() {
    const { on, emit } = useEventBus();

    this.busEmit = emit;

    on('overlay-on', () => (this.isOpened = true));
    on('overlay-off', () => (this.isOpened = false));
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: $zindex-sticky;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;

  &.is-opened {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
